import * as actionTypes from './actionTypes';
import * as actions from './actions';
import * as constants from './constants';
import * as selectors from './selectors';
import * as utils from './utils';
import * as api from './api';
import reducer, {
    entities,
    hasMoreItems,
    continuation,
    hasMoreFollowed,
    continuationFollowed,
    hasMoreForPlace,
    continuationForPlace,
} from './reducer';

export default {
    reducer,
    actionTypes,
    actions,
    constants,
    selectors,
    utils,
    api,
    reducersByKey: {
        entities,
        hasMoreItems,
        continuation,
        hasMoreFollowed,
        continuationFollowed,
        hasMoreForPlace,
        continuationForPlace,
    },
};
